import {withTranslation} from '@wix/yoshi-flow-editor'
import {getElementWidth} from '../../../../../commons/utils/dom'
import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {SideBySideOwnProps, SideBySideStateProps} from './interfaces'
import {SideBySide as SideBySidePresentation} from './side-by-side'

const mapRuntime = ({state, host: {dimensions}}: AppProps): SideBySideStateProps => ({
  width: dimensions.width || getElementWidth(`#${state.component.id}`),
})

export default connect<SideBySideOwnProps, SideBySideStateProps>(mapRuntime)(withTranslation()(SideBySidePresentation))
export * from './interfaces'
